<mat-list class="sidebar">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node class="mat-node" *matTreeNodeDef="let node; when: hasChild">
      <div class="mat-tree-item" matTreeNodeToggle>
        <div>
          @if (node.icon) {
            <mat-icon>{{ node.icon }}</mat-icon>
          }
          <p>{{ node.name }}</p>
        </div>
        <mat-icon
          [ngClass]="{
            rotateUp: treeControl.isExpanded(node),
            rotateDown: !treeControl.isExpanded(node)
          }">
          keyboard_arrow_down
        </mat-icon>
      </div>
    </mat-tree-node>

    <mat-tree-node
      *matTreeNodeDef="let node"
      matTreeNodePadding
      routerLink="{{ node.route }}"
      routerLinkActive="{{ node.active }}">
      <div class="mat-tree-second-item">
        @if (node.icon) {
          <mat-icon class="inner-icon">{{
            node.icon
          }}</mat-icon>
        }
        @if (!node.icon) {
          <div class="circle"></div>
        }
        <p>{{ node.name }}</p>
      </div>
    </mat-tree-node>
  </mat-tree>
</mat-list>
